module.exports = __webpack_public_path__ + "static/media/Pic-05.8cd0af4a.png";